import { FC, SVGProps } from 'react'

export const IconClipboardEdit: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#2C2C36"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 2H9C8.44772 2 8 2.44772 8 3V5C8 5.55228 8.44772 6 9 6H15C15.5523 6 16 5.55228 16 5V3C16 2.44772 15.5523 2 15 2Z"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.42 12.6112C10.615 12.4162 10.8465 12.2615 11.1013 12.156C11.3561 12.0504 11.6292 11.9961 11.905 11.9961C12.1808 11.9961 12.4539 12.0504 12.7087 12.156C12.9635 12.2615 13.195 12.4162 13.39 12.6112C13.585 12.8062 13.7397 13.0377 13.8452 13.2925C13.9508 13.5473 14.0051 13.8204 14.0051 14.0962C14.0051 14.372 13.9508 14.6451 13.8452 14.8999C13.7397 15.1547 13.585 15.3862 13.39 15.5812L7.95 21.0012L4 22.0012L4.99 18.0512L10.42 12.6112Z"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H12.5"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 13.5V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H8"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
